import { useState } from 'react';
import { Hand } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';
import { useUserUpdateMutation } from '../../../redux/setting';
import toast from 'react-hot-toast';

export default function PauseLink() {

  const [paused, setPaused] = useState(() => {
    return localStorage.getItem('linkPaused') === 'true';
  });

  const [updateSettings, { isLoading }] = useUserUpdateMutation();

  const handlePauseToggle = async () => {
    const newPausedValue = !paused;
    setPaused(newPausedValue);
    localStorage.setItem('linkPaused', newPausedValue.toString());

    try {
      await updateSettings({ pause_my_link: newPausedValue }).unwrap();
      toast.success(
        newPausedValue
          ? 'Your link is now paused. 💤'
          : 'Your link is now active. ✅'
      );
    } catch (error: any) {
      const message = error?.data?.message || 'Something went wrong.';
      toast.error(`Failed to update status: ${message}`);
    }
  };

  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm">
        <CustomAppBar title="Pause Link" />

        <div className="bg-white mt-5 rounded-2xl p-6 text-center shadow-md space-y-4">
          <div className="flex justify-center">
            <div className="bg-yellow-100 p-4 rounded-full">
              <Hand className="w-6 h-6 text-yellow-600" />
            </div>
          </div>
          <h2 className="text-lg font-bold">
            {paused ? 'Link is paused ⏸️' : 'Link is active ✅'}
          </h2>
          <p className="text-sm text-gray-600">
            {paused
              ? 'Nobody can send you messages right now.'
              : 'Your link is live. Anyone can message you.'}
          </p>

          <div className="flex justify-center pt-2">
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                className="sr-only"
                checked={paused}
                onChange={handlePauseToggle}
              />
              <div
                className={`w-11 h-6 ${
                  paused ? 'bg-red-500' : 'bg-green-500'
                } rounded-full relative transition duration-200`}
              >
                <div
                  className={`absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-md border transition-transform duration-200 ${
                    paused ? 'translate-x-5' : ''
                  }`}
                ></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

